import { Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import * as S from './style';

function Step({
  title,
  route,
  onClick,
  active,
  completed,
  icon,
  isFirstStep,
  disableClickToCompleted
}) {
  const navigate = useNavigate();

  return (
    <S.Step
      variant="text"
      uppercase
      disabled={!completed && !active}
      isFirstStep={isFirstStep}
      completed={completed}
      onClick={e => {
        if (disableClickToCompleted && completed) {
          return;
        }

        if (onClick) {
          onClick(e);
        } else if (completed && route) {
          navigate(route);
        }
      }}
      startIcon={
        completed ? (
          <S.IconWrapper>
            <Icon name="success" color="var(--color-background-neutral)" />
          </S.IconWrapper>
        ) : (
          icon
        )
      }
    >
      {title}
    </S.Step>
  );
}

export { Step };
